module.exports = "https://static.wanderu.com/ui-react/_next/static/media/phone-with-qr3x.179e2504.png";